module.exports = __webpack_public_path__ + "img/yang.9b78c981.svg";